<mat-table [dataSource]="tableData">

    <!-- Name Column -->
    <ng-container matColumnDef="file">
        <mat-header-cell *matHeaderCellDef translate> File </mat-header-cell>
        <mat-cell *matCellDef="let attachment" style="flex-direction: column;">
            <a style="cursor: pointer"
                (click)="downloadAttachment(attachment)">
                {{attachment.Description}}
            </a>
            <span style="color: grey;">{{attachment.OriginalFileName}}</span>
        </mat-cell>
    </ng-container>

    <!-- Uploaded Column -->
    <ng-container matColumnDef="uploaded">
        <mat-header-cell *matHeaderCellDef translate> Uploaded </mat-header-cell>
        <mat-cell *matCellDef="let attachment">
            {{attachment.DateAttached | date: 'MM/dd/yy'}}
        </mat-cell>
    </ng-container>

    <!-- Uploaded By Column -->
    <ng-container matColumnDef="uploaded by">
        <mat-header-cell *matHeaderCellDef translate> Uploaded By </mat-header-cell>
        <mat-cell *matCellDef="let attachment">
            {{attachment.UploadedBy}}
        </mat-cell>
    </ng-container>

    <!-- Visible to Parents/Students Column -->
    <ng-container matColumnDef="visible to parents students">
        <mat-header-cell *matHeaderCellDef translate> Visible to <br /> Parents/Students </mat-header-cell>
        <mat-cell *matCellDef="let attachment">
            {{attachment.AllowParentToView ? 'Y' : 'N'}}
        </mat-cell>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef translate> Actions </mat-header-cell>
        <mat-cell *matCellDef="let attachment">
            <button style="background-color: inherit; border: none;"
                [matMenuTriggerFor]="actionMenu"
                [matMenuTriggerData]="{attachment: attachment}"
                (click)="$event.stopPropagation()">
                <img src="./assets/images/actions.png" />
            </button>
        </mat-cell>
    </ng-container>

    <!-- Row Definitions -->\
    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columns;" matRipple></mat-row>
</mat-table>

<!-- Action Menu -->
<mat-menu #actionMenu>
    <ng-template matMenuContent let-attachment="attachment">
        <button mat-menu-item class="sis-app-menu" 
            let i = index
            (click)="editAttachment(attachment)" 
            id="editAttachmentButton{{attachment.Id}}"
            translate>
            Edit
        </button>
        <mat-divider>
        </mat-divider>
        <button mat-menu-item class="sis-app-menu" 
            let i = index
            (click)="deleteAttachment(attachment)" 
            id="deleteAttachmentButton{{attachment.Id}}"
            translate>
            Delete
        </button>
    </ng-template>
</mat-menu>